type GridCell = {
  element?: { type?: { _text?: string }; align?: { _text?: string } }
  _attributes?: { colspan?: string; cols?: number }
  _isColspanPlaceholder?: boolean
  _isGridColumnSpacer?: boolean
  _isRowspanPlaceholder?: boolean
}

const FIELD_TYPES_AFTER_LABEL = new Set([
  'text',
  'password',
  'textarea',
  'multilinetext',
  'listbox',
  'combobox',
  'multiselect',
  'date',
  'datetime',
  'daterange',
  'boolean',
  'checkbox',
  'editable',
  'table',
])

function isLabelCell(cell: GridCell | undefined): boolean {
  const t = String(cell?.element?.type?._text ?? '').trim().toLowerCase()
  return t === 'label'
}

function isSkippableCell(cell: GridCell | undefined): boolean {
  if (!cell) return true
  if (cell._isColspanPlaceholder || cell._isGridColumnSpacer || cell._isRowspanPlaceholder) {
    return true
  }
  if (!cell.element) return true
  return false
}

function isFieldAfterLabel(cell: GridCell | undefined): boolean {
  if (!cell?.element) return false
  const t = String(cell.element.type?._text ?? '').trim().toLowerCase()
  return FIELD_TYPES_AFTER_LABEL.has(t)
}

function isDateTimeCell(cell: GridCell | undefined): boolean {
  if (!cell?.element) return false
  const t = String(cell.element.type?._text ?? '').trim().toLowerCase()
  return t === 'date' || t === 'datetime'
}

/**
 * Label in a panel row should hug the next control (Swing: short gap before field).
 */
export function shouldLabelHugAdjacentField(items: GridCell[], itemIndex: number): boolean {
  const cell = items[itemIndex]
  if (!isLabelCell(cell)) return false

  const colspan = parseInt(String(cell._attributes?.colspan ?? '1'), 10) || 1
  if (colspan > 1) return false

  const cols = Number(cell._attributes?.cols) || 0
  if (cols > 12) return false

  const align = String(cell.element?.align?._text ?? 'left').trim().toLowerCase()
  if (align === 'right' || align === 'center') return false

  for (let j = itemIndex - 1; j >= 0; j--) {
    const prev = items[j]
    if (isSkippableCell(prev)) continue
    if (isDateTimeCell(prev)) return false
    break
  }

  for (let j = itemIndex + 1; j < items.length; j++) {
    const next = items[j]
    if (isSkippableCell(next)) continue
    return isFieldAfterLabel(next)
  }
  return false
}
